import bridge from '../../../bridge/bridge';
import { LogApi } from '../types';
import { tryLogAndIgnoreFailure } from '../utils';
import { LogErrorScreenRequest } from './actions';

/**
 * Logs an error related to an error screen.
 *
 * @param error - A descriptive message about the error.
 * @param metadata - (Optional) Additional context, such as the `screenName` where the error occurred.
 */
function logErrorScreen(error: string, metadata?: { screenName?: string }) {
  tryLogAndIgnoreFailure(() =>
    bridge.app.postMessage(new LogErrorScreenRequest(error, metadata))
  );
}

const log: LogApi = {
  logErrorScreen,
};

export { log };
